module.exports = __webpack_public_path__ + "static/pakmaya-my-sm-e3ab71ea4fa8baafd0e2cbe031d25a98.jpg";